export const style = (theme) =>({
  root: {
    width: '100%',
  },
  tableWrapper: {
    // maxHeight: 407,
    overflow: 'auto',
  },
  container: {
    display: "flex",
    flexWrap: "wrap", 
    padding: theme.spacing(3), 
  },
  tableRowHeight: {
    height: 0
  },
  tableCellInCollapes: {
    borderBottom: 'none'
  },
})
export const styleAddPayment = (theme) => ({
  content: {
    padding: '32px 56px'
  },
  button: {
    margin: '0.5rem',
  }, 
}) 